import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TicketService } from 'src/app/private/services/tickets.service';

import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-ticket',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './delete-ticket.component.html',
  styleUrl: './delete-ticket.component.scss'
})
export class DeleteTicketComponent {
  @Input() ticketData: any;
  @Output() closeDialog = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  isLoading = false;

  constructor(
    private ticketService: TicketService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) {}

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  handleDelete() {
    if (!this.ticketData?.id) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Missing Info',
        detail: 'Ticket ID is required to delete.'
      });
      return;
    }

    this.isLoading = true;

    const payload = {
      id: [this.ticketData.id],
      organization_id: this.localStorage.getOrganizationId()
    };

    this.ticketService.deleteTicket(payload).subscribe({
      next: () => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Deleted',
          detail: 'Ticket deleted successfully.'
        });
        this.reload.emit();
        this.closeDialog.emit();
      },
      error: () => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete ticket.'
        });
      }
    });
  }
}
